export const projects  = [
    {
        id: 1,
        img: 'https://i.ibb.co/yBHVywm/covid19.png',
        link: 'https://covid19-aashir.netlify.app/'
    },
    {
        id: 2,
        img: 'https://i.ibb.co/PWFRrvC/expenso.png',
        link: 'https://expenso-mobile.surge.sh/'
    },
    {
        id: 3,
        img: 'https://i.ibb.co/GP4Dw5C/IMS-Splash-Screen.png',
        link: 'https://github.com/AashirKhan21/IMS-Setup'
    },
    {
        id: 4,
        img: 'https://i.ibb.co/P1zLgvh/rlccpng.png',
        link: 'https://rlccpk.org/'
    },
    {
        id: 5,
        img: 'https://i.ibb.co/FxTr7yN/woldp.png',
        link: 'https://thewoldp.com/'
    }
]